module.exports = __webpack_public_path__ + "static/media/kenzie_reeves.8e803e81.png";